<template>
  <v-list style="max-height: 450px; overflow-y: auto">
    <v-list-item v-for="(item, index) in localItems" :key="index">
      <!-- Editable state -->
      <template v-if="editingIndex === index">
        <v-text-field
          v-model="localItems[index].name"
          density="compact"
          @blur="saveEdit(index)"
          @keyup.enter="saveEdit(index)"
          autofocus
        />
      </template>

      <!-- Display state -->
      <template v-else>
        <v-list-item-title @click="startEditing(index)">
          {{ item.name }}
        </v-list-item-title>
      </template>

      <!-- RIGHT SIDE DELETE BUTTON -->
      <template #append>
        <!-- <v-icon
          icon="mdi-delete"
          color="red"
          @click="deleteItem(index)"
          class="cursor-pointer hoverable-shade"
        /> -->

        <GeneralPrompt
          v-if="deletable"
          icon="mdi-delete"
          color="error"
          size="large"
          text="Item will be deleted."
          :iconClasses="'cursor-pointer hoverable-shade'"
          @click="deleteItem(index)"
          @confirm="handleDeleteIndex(index)"
        />
      </template>
    </v-list-item>

    <!-- Add new item -->
    <v-list-item>
      <v-btn variant="text" prepend-icon="mdi-plus" @click="addItem">
        Add Item
      </v-btn>
    </v-list-item>
  </v-list>
</template>

<script setup>
import { ref, watch, toRefs } from "vue";

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  deletable: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const isNewItem = ref(false);
const item = ref(null);
const prevItemName = ref(null);
const emit = defineEmits(["update:items"]);

const toDeleteIndex = ref(null);

// Create a local copy so we can edit before emitting changes
const localItems = ref([...props.items]);
const editingIndex = ref(null);

// Keep localItems in sync if props.items changes
watch(
  () => props.items,
  (newItems) => {
    localItems.value = [...newItems];
  }
);

function startEditing(index) {
  editingIndex.value = index;
  item.value = props.items[editingIndex.value];
  prevItemName.value = item.value.name;
}

function saveEdit(index) {
  editingIndex.value = null;
  if (
    prevItemName.value == undefined ||
    prevItemName.value.trim() != item.value.name.trim()
  ) {
    if (isNewItem.value == true) {
      emit("created", item.value);
    } else {
      emit("updated", item.value);
    }
    isNewItem.value = false;
  }
}

function addItem() {
  console.log("addItem");
  item.value = { name: "New Item" };
  localItems.value.push(item.value);
  //console.log(`localItems = ${JSON.stringify(localItems)}`);
  editingIndex.value = localItems.value.length - 1;
  isNewItem.value = true;
}

function deleteItem(index) {
  toDeleteIndex.value = index;
}

function handleDeleteIndex(index) {
  item.value = props.items[index];
  localItems.value.splice(index, 1);
  editingIndex.value = null;
  console.log(`deleted ${JSON.stringify(item)}`);
  emit("deleted", item.value);
}
</script>

<style>
.hoverable-shade {
  opacity: 0.4;
}

.hoverable-shade:hover {
  opacity: 1;
}
</style>
